import { Fragment, useContext } from 'react'
import { Disclosure } from '@headlessui/react'
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline'
import { Link } from 'react-router-dom'
import NavLogo from './../../freshcart-logo-light.svg'
import { TiShoppingCart } from 'react-icons/ti';
import { VscHeart } from 'react-icons/vsc';
import { AuthContext } from '../../Context/AuthContext.jsx'
import { WishListContext } from '../../Context/WishListContext.jsx'
import { CartContext } from '../../Context/CartContext.jsx'
import { BsCardChecklist } from 'react-icons/bs'
import { CheckOutContext } from '../../Context/CheckOutContext.jsx'
const navigation = [
    // { name: 'Dashboard', href: 'dashboard', current: true },
    { name: 'Home', href: '/', current: false },
    { name: 'Products', href: '/products', current: false },
    { name: 'Contact', href: '/contact', current: false },
]

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

export default function Navbar() {
    const { userToken, logOut } = useContext(AuthContext)
    const { wishItems } = useContext(WishListContext)
    const { cartItems } = useContext(CartContext)
    const { orders } = useContext(CheckOutContext)


    return (
        <Disclosure as="nav" className="bg-slate-100 select-none">
            {({ open }) => (
                <>
                    <div className="mx-auto px-2 sm:px- lg:px-">
                        {/* <div className="mx-auto px-2 sm:px-6 lg:px-8"> */}
                        <div className="relative flex h-16 items-center justify-between">
                            <div className="absolute inset-y-0 right-0 flex items-center md:hidden">
                                {/* Mobile menu button*/}
                                <Disclosure.Button className="flex items-center justify-start rounded-md p-2 text-slate-800 hover:bg-slate-400 hover:text-white focus:outline-none focus:ring-2 focus:ring-inset">
                                    <span className="sr-only">Open main menu</span>
                                    {open ? (
                                        <XMarkIcon className="block h-6 w-6" aria-hidden="true" />
                                    ) : (
                                        <Bars3Icon className="block h-6 w-6" aria-hidden="true" />
                                    )}
                                </Disclosure.Button>
                            </div>
                            <div className="flex flex-1 items-center justify-start sm:items-stretch">
                                <Link to="/" className="flex flex-shrink-0 items-center ">
                                    <img className="block h-8 w-auto md:hidden"
                                        src={NavLogo}
                                        alt="Your Company"
                                    />
                                    <img className="hidden h-8 w-auto md:block"
                                        src={NavLogo}
                                        alt="Your Company"
                                    />
                                </Link>
                                <div className="hidden lg:ml-6 md:block">
                                    <div className="flex space-x-1">
                                        {/* <input type="text" className="rounded-md px-1 border focus:outline-none" placeholder="Search" /> */}
                                        {navigation.map((item) => (
                                            <Link
                                                key={item.name}
                                                to={item.href}
                                                className={classNames(
                                                    item.current ? 'bg-slate-400 text-slate-800' : 'text-slate-800 hover:bg-slate-400 hover:text-slate-50',
                                                    'rounded-md px-3 py-2 text-sm font-medium uppercase focus:bg-slate-400'
                                                )}
                                                aria-current={item.current ? 'page' : undefined}
                                            >
                                                {item.name}
                                            </Link>
                                        ))}
                                    </div>
                                </div>
                            </div>
                            <div className="items-center hidden md:flex">
                                {userToken !== null ? <>
                                    <Link to="/cart" className="relative text-slate-800 mx-2 border border-slate-500 p-2 rounded-full hover:bg-slate-400 hover:text-slate-50">
                                        <span className='absolute text-xs bg-red-600 text-slate-50 font-bold py-1 px-2 rounded-full -top-1/4 -right-1/4 '>{cartItems?.products?.length || 0}</span>
                                        <TiShoppingCart size={20} />
                                    </Link>
                                    <Link to="/wishlist" className="relative text-slate-800 mx-2 border border-slate-500 p-2 rounded-full hover:bg-slate-400 hover:text-slate-50">
                                        <span className='absolute text-xs bg-red-600 text-slate-50 font-bold py-1 px-2 rounded-full -top-1/4 -right-1/4 '>{wishItems?.length}</span>
                                        <VscHeart size={20} />
                                    </Link>
                                    <Link to="/orders" className="relative text-slate-800 mx-2 border border-slate-500 p-2 rounded-full hover:bg-slate-400 hover:text-slate-50 ">
                                        <span className='absolute text-xs bg-red-600 text-slate-50 font-bold py-1 px-2 rounded-full -top-1/4 -right-1/4 '>{orders?.length}</span>
                                        <BsCardChecklist size={20} />
                                    </Link>
                                    <button onClick={logOut} className='rounded-md mx-1 px-3 py-2 text-slate-800 hover:bg-slate-400 hover:text-slate-50 text-sm font-medium uppercase '>Log out</button></>
                                    : <>
                                        <Link to={'/signin'} className='rounded-md px-3 py-2 text-slate-800 hover:bg-slate-400 hover:text-slate-50 text-sm font-medium uppercase '>Sign In</Link>
                                        <Link to={'/signup'} className='rounded-md px-3 py-2 text-slate-800 hover:bg-slate-400 hover:text-slate-50 text-sm font-medium uppercase '>Sign Up</Link>
                                    </>}
                            </div>
                        </div>
                    </div>
                    <Disclosure.Panel className="lg:hidden">
                        <div className="space-y-1 px-2 pb-3 pt-2 ">
                            {navigation.map((item) => (
                                <Link
                                    key={item.name}
                                    as="a"
                                    to={item.href}
                                    className={classNames(
                                        item.current ? 'bg-gray-900 text-slate-800' : 'text-slate-800 hover:bg-slate-400 hover:text-slate-50',
                                        'block rounded-md px-3 py-2 text-base font-medium'
                                    )}
                                    aria-current={item.current ? 'page' : undefined}
                                >
                                    {item.name}
                                </Link>
                            ))}
                        </div>
                        <div className="lg:hidden">
                            <div className="flex flex-col px-2">
                                {userToken ?
                                    <>
                                        <div className="flex">
                                            <Link to="/cart" className="relative text-slate-800 mx-2 border border-slate-500 p-2 rounded-full hover:bg-slate-400 hover:text-slate-50 ">
                                                <span className='absolute text-xs bg-red-600 text-slate-50 font-bold py-1 px-2 rounded-full -top-1/4 -right-1/4 '>{cartItems?.products?.length || 0}</span>
                                                <TiShoppingCart size={20} />
                                            </Link>
                                            <Link to="/wishlist" className="relative text-slate-800 mx-2 border border-slate-500 p-2 rounded-full hover:bg-slate-400 hover:text-slate-50 ">
                                                <span className='absolute text-xs bg-red-600 text-slate-50 font-bold py-1 px-2 rounded-full -top-1/4 -right-1/4 '>{wishItems?.length}</span>
                                                <VscHeart size={20} />
                                            </Link>
                                            <Link to="/orders" className="relative text-slate-800 mx-2 border border-slate-500 p-2 rounded-full hover:bg-slate-400 hover:text-slate-50 ">
                                                <span className='absolute text-xs bg-red-600 text-slate-50 font-bold py-1 px-2 rounded-full -top-1/4 -right-1/4 '>{orders?.length}</span>
                                                <BsCardChecklist size={20} />
                                            </Link>
                                        </div>
                                        <div className="flex flex-col my-2">
                                            <button onClick={logOut} className='rounded-md px-3 py-2 text-slate-800 hover:bg-slate-400 text-left hover:text-slate-50 text-sm font-medium uppercase '>Log out</button>
                                        </div></> : <>
                                        <div className="flex flex-col my-2">
                                            <Link to={'/signin'} className='rounded-md px-3 py-2 text-slate-800 hover:bg-slate-400 hover:text-slate-50 text-sm font-medium uppercase  '>Sign In</Link>
                                            <Link to={'/signup'} className='rounded-md px-3 py-2 text-slate-800 hover:bg-slate-400 hover:text-slate-50 text-sm font-medium uppercase  '>Sign Up</Link>
                                        </div>
                                    </>}
                            </div>
                        </div>
                    </Disclosure.Panel>
                </>
            )}
        </Disclosure>
    )
}
